<script type="text/javascript">
  export default {
  };
</script>

<template>
  <div class="contract-info-loader">
    <div class="contract-info-loader__image">

    </div>
    <div class="contract-info-loader__content">
      <div class="contract-info-loader__text-1"></div>
      <div class="contract-info-loader__text-2"></div>
    </div>
  </div>
</template>

<style lang="scss">
  @import '~styles/settings';

  .contract-info-loader {
    display: flex;
    background: $white;
    margin-bottom: 20px;
    align-items: flex-start;
    gap: 10px;

    &__image {
      border-radius: 4px;
      flex-shrink: 0;

      @include text-line(30px, 30px);
    }

    &__content {
      flex-grow: 1;
    }

    &__text-1 {
      @include text-line(70%, 12px);
    }

    &__text-2 {
      margin-top: 10px;

      @include text-line(100%, 12px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/ContractInfoLoader.vue